<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">

    <!-- เรียกดูข้อมูลแปลง -->
    <div class="row">
        <div class="col-lg-4">
            <div id="formPlot" class="card card-outline card-warning ml-2">
                <div class="card-header">
                    <h3 class="card-title "><span class="headText2">ขอแก้ไขข้อมูลแปลงอ้อย ปี {{ yearSelected }}</span>
                    </h3>
                    <div class="card-tools ">
                        <button (click)="refresh();" type="button" class="btn btn-tool text-primary"><i
                            class="fas fa-sync-alt"></i></button>
                        <button type="button" class="btn btn-tool text-primary" data-card-widget="maximize"><i
                                class="fas fa-expand"></i></button>
                        <button type="button" class="btn btn-tool text-primary" data-card-widget="collapse"><i
                                class="fas fa-minus"></i>
                        </button>
                    </div>
                    <!-- /.card-tools -->
                </div>
                <!-- /.card-header -->
                <div class="card-body">
                    <form #frm_selecPlot="ngForm">
                        <div class="input-group-prepend">
                            <label>เลือกแปลงอ้อย</label>
                        </div>
                        <input #itid ngModel name="itid" type="text" class="form-control" list="cpdata" id="itid"
                            (change)="selectData(frm_selecPlot.value)">
                        <datalist id="cpdata">
                            <option *ngFor="let item of plotinSupzone" [value]="item.itid">
                                {{item.intlandno}} {{item.fmname}} {{item.canetype}} {{item.landvalue}} ไร่ รูท
                                {{item.route}}
                            </option>
                        </datalist>
                    </form>
                    <div class="callout callout-warning mt-2">
                        <p>แปลง {{ plotSelect.intlandno }}
                            <br>{{ plotSelect.CaneTypeName }} {{ plotSelect.landvalue }} ไร่ รูท {{ plotSelect.route }}
                        </p>
                        <footer class="blockquote-footer headText text-primary">{{ plotSelect.fmname }}</footer>
                    </div>
                </div>
                <!-- /.card-body -->
            </div>
        </div>
        <div class="col-lg-8">
            <div id="aboutPlot" class="card card-outline card-warning mr-2">
                <div class="card-header">
                    <h3 class="card-title "><span class="headText2">รายการขอเกี้ยวและปัจจัยแปลง ปี {{ yearSelected }}
                        </span></h3>
                    <div class="card-tools ">
                        <button type="button" class="btn btn-tool text-primary" data-card-widget="maximize"><i
                                class="fas fa-expand"></i></button>
                        <button type="button" class="btn btn-tool text-primary" data-card-widget="collapse"><i
                                class="fas fa-minus"></i>
                        </button>
                    </div>
                    <!-- /.card-tools -->
                </div>
                <!-- /.card-header -->
                <div class="card-body">
                    <p class="headText1 text-primary"><i class="fas fa-money-check-alt"></i> เกี้ยว</p>
                    <ul class="list-group list-group-flush">
                        <li *ngFor="let item of financeList" class="list-group-item">
                            - {{ item.datepost | adtob }} ,
                            {{ item.comment1 }} ,
                            <kbd> {{ item.money_amt | number }} </kbd> ,
                            {{ item.docdesc }}
                        </li>
                    </ul>
                    <p class="headText1 text-primary"><i class="fas fa-baby-carriage"></i> ปัจจัย</p>
                    <ul class="list-group list-group-flush">
                        <li *ngFor="let item of factorList" class="list-group-item">
                            - {{ item.datepost | adtob }} ,
                            <span *ngIf="item.amt1>0">{{ item.desc1 }} จำนวน {{ item.amt1 | number }} ,</span>
                            <span *ngIf="item.amt2>0">{{ item.desc2 }} จำนวน {{ item.amt2 | number }} ,</span>
                            <span *ngIf="item.amt3>0">{{ item.desc3 }} จำนวน {{ item.amt3 | number }} ,</span>
                            <span *ngIf="item.amt4>0">{{ item.desc4 }} จำนวน {{ item.amt4 | number }} ,</span>
                        </li>
                    </ul>
                </div>
                <!-- /.card-body -->
            </div>
        </div>
    </div>

    <!-- ฟอร์มขอแก้ไขแปลง -->
    <div class="row">
        <div class="col-lg-12">
            <div *ngIf="plotSelect" id="formEditPlot" class="card card-outline card-primary ml-2">
                <div class="card-header">
                    <h3 class="card-title "><span class="headText2">ฟอร์มแก้ไขข้อมูลแปลง ปี {{ yearSelected }}</span>
                    </h3>
                    <div class="card-tools ">
                        <button type="button" class="btn btn-tool text-primary" data-card-widget="maximize"><i
                                class="fas fa-expand"></i></button>
                        <button type="button" class="btn btn-tool text-primary" data-card-widget="collapse"><i
                                class="fas fa-minus"></i>
                        </button>
                    </div>
                    <!-- /.card-tools -->
                </div>
                <div class="card-body">
                    <div class="callout callout-info mt-2">
                        <p [ngClass]="plotCanEdit==false ? 'headText1 bg-danger' : 'headText1 bg-success' ">
                            แปลง {{ plotSelect.intlandno }} {{ plotSelect.fmname }} {{ plotSelect.CaneTypeName }} {{
                            plotSelect.landvalue }} ไร่ รูท {{ plotSelect.route }}</p>
                        <strong *ngIf="!plotCanEdit"
                            class="text-danger">!!!แจ้งเพื่อทราบ..แปลงนี้มีการเบิกเกี้ยวหรือปัจจัยไปแล้ว
                            ผจก.ส่วนจะต้องดำเนินการในขั้นตอนให้แล้วเสร็จก่อนการแก้ไข</strong>
                        <strong *ngIf="plotCanEdit" class="text-success">(^_^)แปลงนี้มีไม่มีการเบิกเกี้ยวหรือปัจจัย
                            ผจก.ส่วนสามารถอนมุัติการแก้ไขได้</strong>
                    </div>

                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text">เลือกหัวข้อการขอแก้ไข</span>
                            </div>
                            <select (change)="showForm($event)" class="form-control" name="selectForm">
                                <option value="" disabled selected>++เลือกหัวข้อ++</option>
                                <option *ngFor="let item of subjectList" [value]="item.edit_type">{{ item.edit_type_name}}</option>
                            </select>
                        </div>
                        
                        <!-- ฟอร์มยกเลิกแปลง -->
                        <form *ngIf="formSelect ==1" #frm_edit1="ngForm">
                            <input type="hidden" #edit_type="ngModel" ngModel name="edit_type" [(ngModel)]="defaultValue[0]">
                            <input type="hidden" #itid="ngModel" ngModel name="itid" [(ngModel)]="plotSelect.itid">
                            <input type="hidden" #edit_from="ngModel" ngModel name="edit_from" [(ngModel)]="defaultValue[1]">
                            <input type="hidden" #edit_to="ngModel" ngModel name="edit_to" [(ngModel)]="defaultValue[2]">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">ป้อนเหตุผล</span>
                                </div>
                                <input #comment="ngModel" ngModel name="comment" class="form-control"
                                    [ngClass]="{'is-invalid' : comment.invalid && (comment.dirty || comment.touched)}"
                                    required>
                                <div class="invalid-feedback">
                                    <span *ngIf="comment.hasError('required')">กรุณาป้อนเหตุผลการขอแก้ไข</span>
                                </div>
                            </div>
                            <button (click)="saveRequestEditPlotManager(frm_edit1.value);frm_edit1.resetForm();" type="submit"
                                [disabled]="frm_edit1.invalid" class="btn btn-outline-success"><i class="fas fa-save">
                                    บันทึก</i></button>
                            <!-- {{ frm_edit1.value | json }} -->
                        </form>

                        <!-- ฟอร์มแก้ประเภทอ้อย -->
                        <form *ngIf="formSelect ==2" #frm_edit2="ngForm">
                            <input type="hidden" #edit_type="ngModel" ngModel name="edit_type" [(ngModel)]="defaultValue[0]">
                            <input type="hidden" #itid="ngModel" ngModel name="itid" [(ngModel)]="plotSelect.itid">
                            <input type="hidden" #edit_from="ngModel" ngModel name="edit_from" [(ngModel)]="plotSelect.canetype">
                            <div  class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">ข้อมูลเดิม >> <span class="text-danger headText1"> [ {{ plotSelect.CaneTypeName }} ] </span> >> ขอแก้ไขเป็น >></span>
                                </div>
                                <select #edit_to="ngModel" ngModel name="edit_to" class="form-control"
                                    [ngClass]="{'is-invalid' : edit_to.invalid && (edit_to.dirty || edit_to.touched)}" 
                                    required>
                                    <option value="" disabled selected>++ประเภทอ้อย++</option>
                                    <option *ngFor="let item of canetype" [value]="item.code">{{ item.name}}</option>
                                </select>
                                <div class="invalid-feedback">
                                    <span *ngIf="edit_to.hasError('required')">กรุณาเลือก ประเภทอ้อยที่จะขอแก้ไข</span>
                                </div>
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">ป้อนเหตุผล</span>
                                </div>
                                <input #comment="ngModel" ngModel name="comment" class="form-control"
                                    [ngClass]="{'is-invalid' : comment.invalid && (comment.dirty || comment.touched)}"
                                    required>
                                <div class="invalid-feedback">
                                    <span *ngIf="comment.hasError('required')">กรุณาป้อนเหตุผลการขอแก้ไข</span>
                                </div>
                            </div>
                            <button (click)="saveRequestEditPlotManager(frm_edit2.value);frm_edit2.resetForm();" type="submit"
                                [disabled]="frm_edit2.invalid" class="btn btn-outline-success"><i class="fas fa-save">
                                    บันทึก</i></button>
                            <!-- {{ frm_edit2.value | json }} -->
                        </form>

                        <!-- ฟอร์มแก้เจ้าของแปลง -->
                        <form *ngIf="formSelect ==3" #frm_edit3="ngForm">
                            <input type="hidden" #edit_type="ngModel" ngModel name="edit_type" [(ngModel)]="defaultValue[0]">
                            <input type="hidden" #itid="ngModel" ngModel name="itid" [(ngModel)]="plotSelect.itid">
                            <input type="hidden" #edit_from="ngModel" ngModel name="edit_from" [(ngModel)]="plotSelect.fmcode">
                            <div  class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        ข้อมูลเดิม >> <span class="text-danger headText1"> [ {{ plotSelect.fmname }} ] </span> 
                                        >> ขอแก้ไขเป็น >> <span class="text-primary headText1">[ {{ fmname }} ]</span>
                                    </span>
                                </div>
                                <input (change)="sheachFm($event)" #edit_to="ngModel" ngModel name="edit_to" class="form-control"
                                    [ngClass]="{'is-invalid' : edit_to.invalid && (edit_to.dirty || edit_to.touched)}"
                                    placeholder="ป้อนโควตา 10 หลัก" minlength="10" required>
                                <!-- <div class="input-group-prepend">
                                    <span class="input-group-text"> {{ fmname }} </span>
                                </div> -->
                                <div class="invalid-feedback">
                                    <span *ngIf="edit_to.hasError('required')">กรุณาป้อนโควตาชาวไร่</span>
                                    <span *ngIf="edit_to.hasError('minlength')">โควตา 10 หลัก</span>
                                </div>
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">ป้อนเหตุผล</span>
                                </div>
                                <input #comment="ngModel" ngModel name="comment" class="form-control"
                                    [ngClass]="{'is-invalid' : comment.invalid && (comment.dirty || comment.touched)}"
                                    required>
                                <div class="invalid-feedback">
                                    <span *ngIf="comment.hasError('required')">กรุณาป้อนเหตุผลการขอแก้ไข</span>
                                </div>
                            </div>
                            <button (click)="saveRequestEditPlotManager(frm_edit3.value);frm_edit3.resetForm();" type="submit"
                                [disabled]="frm_edit3.invalid" class="btn btn-outline-success"><i class="fas fa-save">
                                    บันทึก</i></button>
                            <!-- {{ frm_edit3.value | json }} -->
                        </form>
                </div>
            </div>
        </div>
    </div>

    <!-- รายการขอแก้ไขแปลงของ supzone -->
    <div class="row">
        <div class="col-lg-12">
            <div id="listRequest" class="card card-outline card-success ml-2 mr-2">
                <div class="card-header">
                    <h3 class="card-title "><span class="headText2">รายการขอแก้ไขข้อมูลแปลงอ้อยของท่าน</span></h3>
                    <div class="card-tools ">
                        <button type="button" class="btn btn-tool text-primary" data-card-widget="maximize"><i
                                class="fas fa-expand"></i></button>
                        <button (click)="requestData();" type="button" class="btn btn-tool text-primary"><i
                                class="fas fa-sync-alt"></i></button>
                        <button type="button" class="btn btn-tool text-primary" data-card-widget="collapse"><i
                                class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="card-body table-responsive p-2" style="height: 500px">
                        <table #tb_data class="table table-hover table-head-fixed text-nowrap">
                            <thead>
                                <tr class="headText text-primary">
                                    <th>วันที่</th>
                                    <th>ข้อมูลแปลง</th>
                                    <th>หัวข้อ</th>
                                    <th>เหตุผล</th>
                                    <th>สถานะ</th>
                                    <th class="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of dataApi">
                                    <td class="align-middle">{{ item.date_add | adtob }}</td>
                                    <td class="align-middle">
                                        {{ item.intlandno }} {{ item.fmname }} {{ item.canetype }}
                                        {{ item.landvalue }} ไร่ รูท {{ item.route }}
                                    </td>
                                    <td>{{ item.edit_type_name }}</td>
                                    <td>{{ item.comment }}</td>
                                    <td>{{ item.edit_status_doc }}</td>
                                    <!-- <td [ngClass]="[ item.schedule==1 && item.status_sv !=5 ? 'bg-warning align-middle' : 'align-middle' ]">{{ item.date_schedule | adtob }}</td> -->
                                    <td class="text-center align-middle">
                                        <!-- <a (click)="modalUpdataaudit(item.dataid)" data-bs-toggle="modal"
                                                data-bs-target="#explan_plant">
                                                <i class="fas fa-edit"></i>
                                            </a> -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>

<app-footer></app-footer>